<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="color: black; background-color: #fff">
            <h6>{{TitleProfitAmount}}</h6>
            <div class="text-center">
                <h4 class="fix-margin">
                    {{ProfitAmount}}
                    <span  v-if="needCurrency" style="font-size: 1.5rem">
                    {{' ' + $t('currency.rial')}}
                    </span>
                    <span  v-if="needPercent" style="font-size: 1.5rem">
                    {{' ' + $t('marketing.dashboard.percentage')}}
                    </span>
                </h4>
            </div>
            <div class="line-divider mt-4 mb-3"></div>
            <h6>{{TitleBalance}}</h6>
            <div class="text-center">
                <h4 class="fix-margin">
                    {{Balance}}
                    <span style="font-size: 1.5rem">
                            {{' ' + $t('currency.rial')}}
                    </span>
                </h4>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "",

        props: {
            TitleBalance: {
                default() {
                    return {}
                }
            },
            TitleProfitAmount: {
                default() {
                    return {}
                }
            },
            TitleSettlement: {
                default() {
                    return {}
                }
            },
            MarketingStatus: {
                default() {
                    return {}
                }
            },
            Balance: {
                default() {
                    return {}
                }
            },
            ProfitAmount: {
                default() {
                    return {}
                }
            },
            SettlementedAmount: {
                default() {
                    return {}
                }
            },
            needCurrency: {
                default() {
                    return {}
                }
            },
            needPercent: {
                default() {
                    return {}
                }
            }
        },

    }
</script>

<style>

</style>